var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"--dark":"#000 !important"},attrs:{"id":"app"}},[_c('top-nav'),_c('search-filter'),_c('router-view'),_c('navigation-sidebar'),(_vm.user && !_vm.user.hasCompletedOnboarding)?_c('onboarding'):_vm._e(),_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }